import { money } from "./money";

/**
 * The suffix on an overage ceiling or an accrued total — the two figures that
 * stay net, by decision, everywhere they are shown.
 *
 * Unlike a plan's price or the overage rate, a ceiling is a number a studio
 * typed and an accrued total is a running sum `setOverage`/`getEntitlement`
 * maintain — grossing either one up here would be a second, driftable
 * computation of what GST turns it into, on the two figures the server never
 * recomputes with tax added. GST is real and is added only at the moment an
 * addon is actually charged — the Razorpay amount, and the invoice line that
 * follows it — which is what this suffix says without doing the arithmetic
 * itself.
 */
export const GST_WHEN_CHARGED = "+ GST when charged";

/** A net overage figure (a ceiling or an accrued total), labelled — never gross. */
export function netOverageWords(minorUnits: number, currency: string): string {
  return `${money(minorUnits, currency)} ${GST_WHEN_CHARGED}`;
}
